import React      from 'react';
import classNames from 'classnames';

function renderTextWithImageBlock(data, index) {
  const {
          ALT,
          BACKGROUND_COLOR,
          CONTENT,
          IMAGE = [],
          TEXT_POSITION,
        }     = data;
  const [img] = IMAGE;

  /**
   * @param {number} size
   * @param {string} [ext='png']
   *
   * @returns {string}
   */
  const getSrc = (size, ext = 'png') => {
    return `${img}.${ext}?w=${size}&default=horizontal&t=${BUILD_TIME}`;
  };

  const src = getSrc(400);

  return (
    <section key={index} style={{ backgroundColor: BACKGROUND_COLOR }}>
      <div className={'container'}>
        <div className={classNames('withImage', { reverse: TEXT_POSITION === 'left' })}>
          <picture>
            {!(img?.endsWith('.svg') || img?.endsWith('.gif')) ? (
              <>
                <source srcSet={getSrc(400, 'webp')} type={'image/webp'} />
                <source srcSet={src} type={'image/png'} />
                <img src={src} alt={ALT} />
              </>
            ) : (
              <img src={img} alt={ALT} />
            )}
          </picture>
          <div dangerouslySetInnerHTML={{ __html: CONTENT }} />
        </div>
      </div>
    </section>
  );
}

export default renderTextWithImageBlock;